import get from 'lodash/get';
import * as Sentry from '@sentry/browser';
import shouldLogToSentry from '../../common/utils/shouldLogToSentry';

export default function apiClientEffectsErrorCallback(err) {
  if (!shouldLogToSentry()) {
    // eslint-disable-next-line no-console
    console.error(err);
    return;
  }

  if (!err.response || err.statusCode >= 500) {
    Sentry.captureException(err, {
      extra: {
        serial: get(err, 'config.params.serial'),
      },
      tags: {
        apiRequestUrl: get(err, 'config.url'),
      },
    });
  }
}
